import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Button } from '@gem/ui-kit';

import { useJoinButtonPresenter } from './JoinButton.presenter';

interface IJoinButtonProps {
  className?: string;
  groupId: string;
}

export const JoinButton: FC<IJoinButtonProps> = observer((props) => {
  const { className, groupId } = props;
  const presenter = useJoinButtonPresenter(groupId);

  return (
    <Button
      className={className}
      onClick={presenter.onClick}
      isLoading={presenter.isLoading}
      theme="primary"
    >
      {presenter.title}
    </Button>
  );
});
